import styled from "styled-components";

export const Container = styled.div`
    background-color: ${props => props.theme.colors.background.azureishWhite};
    padding: 1rem;
    min-height: calc(100vh - 2rem);
`;
